export const UPDATE_SITE_DATA = 'UPDATE_SITE_DATA';
export const ADD_DOCUMENT_ELEMENTS = 'ADD_DOCUMENT_ELEMENTS';
export const NAVIGATE_TO_PATH = 'NAVIGATE_TO_PATH';
export const PREVIEW_FRAME_MOUNTED = 'PREVIEW_FRAME_MOUNTED';
